export const DATETIME = {
  DATETIME_FORMAT: 'YYYY-MM-DD HH:mm',
  DATE_FORMAT: 'YYYY-MM-DD',
  DATETIME_FORMAT_DISPLAY: 'DD/MM/YYYY HH:mm',
  DATE_FORMAT_DISPLAY: 'DD/MM/YYYY'
}



// WEBPACK FOOTER //
// ./src/constants/datetime.js